import { defineStore } from 'pinia';
import AdminSetupService from '@/service/AdminSetupService';

export const useAdminSetupStore = defineStore('AdminSetupStore', {
  state: () => ({
    emailConfig: {},
    expiredConfig: {
      emailDepositDue: {
        dayDefault: 0,
        exclusions: {}
      },
      emailPaymentDue: {
        dayDefault: 0,
        exclusions: {}
      },
      emailPassengerListDue: {
        dayDefault: 0,
        exclusions: {}
      },
      emailQuoteExpiring: {
        dayDefault: 0,
        exclusions: {}
      },
      airExp: {
        dayDefault: 0,
        exclusions: {}
      },
      hotelExp: {
        dayDefault: 0,
        exclusions: {}
      },
      cruiseExp: {
        dayDefault: 0,
        exclusions: {}
      },
      packageExp: {
        dayDefault: 0,
        exclusions: {}
      },
      mdtExp: {
        dayDefault: 0,
        exclusions: {}
      }
    },
    templateData: {},
    departureConfig: {},
    optionConfig: {},
    minimumConfig: {
      packageConfig: {
        minPax: 0,
        minRoomsCabins: 0
      },
      hotelConfig: {
        minPax: 0,
        minRoomsCabins: 0
      },
      airConfig: {
        minPax: 0,
        minRoomsCabins: 0
      },
      cruiseConfig: {
        minPax: 0,
        minRoomsCabins: 0
      },
      tourConfig: {
        minPax: 0,
        minRoomsCabins: 0
      }
    }
  }),

  actions: {
    async updateEmailConfig(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateEmailConfig(payload);
      return res?.data;
    },

    async getExpiredConfig() {
      const Service = new AdminSetupService();
      const res = await Service.getExpiredConfig();
      this.expiredConfig = res?.data;
      return res?.data;
    },

    async getConfigOption() {
      const Service = new AdminSetupService();
      const res = await Service.getConfigOption();
      this.optionConfig = res?.data;
      return res?.data;
    },

    async updateExpiredConfig(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateExpiredConfig(payload);
      return res?.data;
    },

    async updateConfigOption(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateConfigOption(payload);
      return res?.data;
    },

    async getOneWayOpenJawConfig(jawType: string) {
      const Service = new AdminSetupService();
      const res = await Service.getOneWayOpenJawConfig(jawType);
      return res;
    },

    async updateOneWayOpenJawConfig(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateOneWayOpenJawConfig(payload);
      return res;
    },

    async getSpecialPromotionConfiguration() {
      const Service = new AdminSetupService();
      const res = await Service.getSpecialPromotionConfiguration();
      return res;
    },

    async updateSpecialPromotionConfiguration(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateSpecialPromotionConfiguration(payload);
      return res;
    },

    async getNetMarginConfig() {
      const Service = new AdminSetupService();
      const res = await Service.getNetMarginConfig();
      return res;
    },

    async updateNetMarginConfig(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateNetMarginConfig(payload);
      return res;
    },

    async getDepartureConfig() {
      const Service = new AdminSetupService();
      const res = await Service.getDepartureConfig();
      this.departureConfig = res?.data;
      return res?.data;
    },

    async updateDepartureConfig(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateDepartureConfig(payload);
      return res?.data;
    },

    async getMaxRoomConfig() {
      const Service = new AdminSetupService();
      const res = await Service.getMaxRoomConfig();
      this.departureConfig = res?.data;
      return res?.data;
    },

    async updateMaxRoomConfig(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateMaxRoomConfig(payload);
      return res?.data;
    },

    async checkMaxRooms(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.checkMaxRooms(payload);
      return res?.data;
    },

    async getMinimumConfig() {
      const Service = new AdminSetupService();
      const res = await Service.getMinimumConfig();
      this.minimumConfig = res?.data;
      return res?.data;
    },

    async updateMinimumConfig(payload: any) {
      const Service = new AdminSetupService();
      const res = await Service.updateMinimumConfig(payload);
      return res?.data;
    }
  }
});
